import * as React from "react";

type ArticleTileProps = {
    image: string;
    title: string;
    date: string;
    type: string;
    description: string;
    pageUrl: string;
    id: string;
    readMoreText: string;
    author: string;
    isBlog: boolean;
};


export default class ArticleTile extends React.Component<ArticleTileProps, {}> {
    constructor(props: ArticleTileProps) {
        super(props);
    }

    public render() {
        return (
            <div className="article-list-item" key={this.props.id}>
                <div className="content">
                { (this.props.image) && 
                    <div className="article-list-image-container">
                        <img className="article-list-image" loading="lazy" src={this.props.image} alt="" />
                        {(this.props.author) && (this.props.isBlog == true) &&
                            <div className="article-list-image-author">{this.props.author}
                            </div>
                        }
                </div>
                }
                
                <div className="article-list-content p-3">
                    <h3 className="article-list-title">{this.props.title}</h3>
                    <p>
                            <span className="article-list-date">{this.props.date}</span>
                            { (this.props.type) &&
                                <span>
                                    <span className="article-list-slash"> / </span>
                                    <span className="article-list-type">{this.props.type}</span>
                                </span>
                            }
                    </p>
                    <div className="article-list-description" dangerouslySetInnerHTML={{ __html: this.props.description }}></div>
                    <a className="article-list-link" href={this.props.pageUrl}>{this.props.readMoreText}</a>
                    </div>
                </div>
            </div>
        )
    }
}
